import React from "react";
import "./HomeSkeleton.css";

const TAB_COUNT = 5;
const CARD_COUNT = 6;

// Placeholder for the home page's first menu load: category tabs + product cards.
// Reuses the product card classes (ord-gutter / box / product-img-wrapper / cnts) so it matches the real layout.
const HomeSkeleton = () => (
  <div className="home-skeleton" role="status" aria-busy="true">
    <span className="sr-only">Loading menu...</span>

    <div className="home-skeleton-tabs" aria-hidden="true">
      {Array.from({ length: TAB_COUNT }).map((_, i) => (
        <div key={i} className="sk home-skeleton-tab" />
      ))}
    </div>

    <div className="ord-gutter" aria-hidden="true">
      <div className="heading">
        <div className="sk home-skeleton-heading" />
      </div>
      <div className="row">
        {Array.from({ length: CARD_COUNT }).map((_, i) => (
          <div key={i} className="col-xl-6">
            <div className="box">
              <div className="row">
                <div className="col-6 product-img-wrapper">
                  <div className="sk home-skeleton-img" />
                </div>
                <div className="col-6 cnts">
                  <div>
                    <div className="sk home-skeleton-line home-skeleton-title" />
                    <div className="sk home-skeleton-line" />
                    <div className="sk home-skeleton-line home-skeleton-line-short" />
                  </div>
                  <div>
                    <div className="sk home-skeleton-line home-skeleton-price" />
                    <div className="sk home-skeleton-btn" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default HomeSkeleton;
